<template>
  <div class="page-detail">
  <div class="txt">
    本用户条款是您与小铃铛护理服务（上海）有限公司之间关于使用本小程序的法律协议，旨在规范您对小程序的使用，保护双方的合法权益。在使用本小程序之前，请您仔细阅读本用户条款的全部内容。当您使用本小程序时，即表示您已充分阅读、理解并同意接受本用户条款的约束。【审慎阅读】您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。如您对协议有任何疑问，可向小铃铛客服咨询。如您未满18周岁，或以其他形式被限制民事行为能力，请在监护人的陪同下阅读本协议。<br>
    【词汇定义】本文中所用词汇定义如下：<br>
    小铃铛：指小铃铛护理服务（上海）有限公司推出的？？健康服务信息平台，为全国患者提供？？？？？？？？？？？？等信息服务。本平台包括小铃铛网站、小铃铛移动客户端及其他现在或将来推出的基于小铃铛的信息平台。<br>
    用户：指阅读并同意本协议内容，经过小铃铛注册程序成为使用小铃铛各项产品/服务的个人。（以下更多称为“您”)br
    小铃铛管理规定：<br>
    指包括本协议在内的，由用户签署，或由小铃铛在明显位置展示的，具有规范用户行为作用的各类规定、提示、声明文件，陪护人员企业微信联络您，不得添加微信。<br><br>


    一、协议的范围<br><br>

1. 适用范围：本协议适用于您对本小程序的所有使用行为，包括但不限于访问小程序、使用小程序提供的服务、参与小程序内的活动等。<br><br>

2.协议变更：小铃铛护理服务（上海）有限公司]有权根据法律法规变化、业务发展需要等对本协议进行修改。修改后的协议将在小程序上公布，公布后即视为已通知您。若您在协议变更后继续使用小程序，即表示您接受变更后的协议。<br>
3.小铃铛在提供信息服务时，可能会对部分服务收取一定费用，小铃铛将会对收费服务给予明确的提示，如您拒绝支付此类费用，小铃铛有权不提供相关服务。<br>
4.小铃铛将免费为需要该服务的患者或用户提供投保，需要收集该患者或用户的真实姓名和身份证，其中注册账户的手机号是小铃铛提供基础服务所必须的。<br><br>

二、用户的权利和义务<br><br>

1.遵守法律法规：您应遵守国家相关法律法规以及本协议的规定，不得利用本小程序从事任何违法、侵权、欺诈、恶意骚扰等活动，不得干扰小程序的正常运营，不得侵犯小程序运营方及其他第三方的合法权益。<br>
2.用户应自行诚信向本客户端提供注册资料，用户保证其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。如果用户提供的注册资料不合法、不真实、不准确、不详尽的，用户需承担因此引起的相应责任及后果，并且小铃铛保留因用户注册资料合法、不真实、不准确、不详尽而终止用户使用小铃铛各项服务的权利。<br>
3.用户在本客户端进行付费活动时，涉及用户真实姓名/名称、通信地址、联系电话、电子邮箱等隐私信息的，小铃铛将予以严格保密，除非得到用户的授权或法律另有规定，小铃铛不会主动向外界披露用户隐私信息。<br><br>

2. 行为责任：您需自行对在小程序上的行为负责，包括但不限于发布的信息、参与的互动、发起的交易等。确保所发布的内容真实、准确、合法，不包含虚假、误导、违法或侵犯他人权益的信息。用户不得将在小铃铛注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，并与实际使用人承担连带责任。<br><br>

3. 信息提供：在使用小程序时，您应提供真实、准确、完整的个人信息，并及时更新。不得冒用他人身份或使用虚假信息注册、登录。若因您提供的信息有误或不完整导致的任何问题，由您自行承担责任。<br><br>

4. 安全使用：不得利用小程序从事任何影响小程序安全的行为，如进行病毒攻击、网络钓鱼、恶意篡改数据、破解小程序代码等。保护好自己的账号和密码安全，不得将账号和密码透露给他人。若因您自身原因导致账号和密码泄露，由此产生的一切后果由您自行承担 。<br><br>

5.禁止商业滥用：未经小程序运营方书面许可，不得利用本小程序进行未经授权的商业活动，如发布商业广告、推销商品或服务、开展盈利性活动等；不得进行刷量、刷单、作弊等不正当行为，扰乱小程序的运营秩序和公平竞争环境。<br><br>

三、小程序运营方的权利和义务<br><br>

1.服务提供：小程序运营方将尽力为您提供稳定、安全、高效的小程序服务，但对于因不可抗力、技术故障、网络问题等不可预见、不可避免的原因导致的服务中断、延迟或其他问题，小程序运营方不承担责任 。<br>
2.平台不会将您的个人信息转移或披露给任何非关联的第三方，除非：<br>
(1）相关法律法规或法院、政府机关要求;<br>
(2） 为完成合并、分立、收购或资产转让而转移；<br>
(3） 为提供您要求的服务所必需。<br><br>

2. 监管权利：小程序运营方有权对您使用小程序的行为进行监管，若发现您违反本协议规定，有权采取相应措施，包括但不限于限制您的使用权限、暂停或终止您的账号、删除您发布的违规信息、要求您赔偿损失等。<br><br>

3. 内容审核：小程序运营方有权对您在小程序上发布的内容进行审核，对于不符合法律法规、本协议规定或小程序运营方价值观的内容，有权进行删除、屏蔽或限制展示。<br><br>

4.协议通知：小程序运营方将通过小程序内公告、消息推送等方式向您通知本协议的变更、重要事项等信息，您应及时关注小程序内的通知消息。<br><br>

四、用户依法言行义务<br>
本协议依据国家相关法律法规规章制定，用户同意严格遵守以下义务：<br>
(1） 不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；<br>
(2） 从中国大陆向境外传输资料信息时必须符合中国有关法规；<br>
(3） 不得利用本客户端从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；<br>
（4） 不得干扰本客户端的正常运转，不得侵入本客户端及国家计算机信息系统；<br>
（5） 不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、淫秽的、不文明的等信息资料；<br>
（6）不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；<br>
（7） 不得教唆他人从事本条所禁止的行为；<br>
（8） 不得利用在本客户端注册的账户进行牟利性经营活动；<br>
（9） 不得发布任何侵犯他人著作权、商标权等知识产权或合法权利的内容；用户应关注并遵守本客户端不时公布或修改的各类合法规则规定。本客户端保有删除各类不符合法律政策或不真实的信息内容而无须通知用户的权利。<br>
若用户未遵守以上规定的，本客户端有权作出独立判断并采取暂停或关闭用户帐号等措施。用户须对自己在网上的言论和行为承担法律责任。<br><br>

五、 网上预约<br>
5.1 用户发起上门预约服务时，需仔细确认预约服务的名称、价格、数量、说明、注意事项、联系地址、电话、联系人等信息。联系人与用户本人不一致的，联系人的行为和意思表示视为用户的行为和意思表示，用户应对联系人的行为及意思表示的法律后果承担连带责任。<br>
5.2 除法律另有强制性规定外，双方约定如下：<br>
(1） 本客户端上小铃铛展示的服务和价格等信息仅仅是要约邀请，您预约时须填写您希望预约的服务数量、价款及支付方式、联系人、联系方式、联系地址(合同履行地点）、合同履行方式等内容；系统生成的预约信息是计算机信息系统根据您填写的内容自动生成的数据，仅是您向小铃铛注册的？？？？？？人员发出的合同要约；<br>
(2） 小铃铛收到您的预约信息后,<br>
只有在小铃铛将您在预约的服务向您或指定联系人交付时 （以接受预约服务为准），方视为您与小铃铛注册的？？？？？？人员之间就向您或指定联系人提供的服务建立了合同关系；<br>
(3） 如果您在一份预约里预订了多份服务并且小铃铛只给您或指定联系人交付了部分服务时，您与小铃铛注册的？？？？？？？人员之间仅就实际向您或指定联系人提供的服务建立了合同关系；<br>
(4） 只有在小铃铛注册的？？？？？等人员实际向您或指定联系人提供了预约中预订的其他服务时，您和小铃铛注册的？？？？？？？等人员之间就预约中该其他已实际向您或指定联系人提供的服务才成立合同关系。您可以随时登录您在本客户端注册的账户，查询您的预约状态。<br>
5.3 由于市场变化及各种以合理商业努力难以控制的因素的影响，本客户端无法保证您提交的预约信息中希望预订的服务都能提供；如您拟预订的服务，发生无法提供的情形，您有权取消预约。<br><br>

六、知识产权<br><br>

1. 归属权：本小程序所包含的所有内容，如文字、图片、音频、视频、软件、程序、图标等，其知识产权均归小程序运营方或相关权利人所有，受到法律法规的保护。<br><br>

2. 使用限制：未经小程序运营方书面许可，您不得将小程序的任何内容用于商业目的，不得进行复制、修改、传播、分发、公开展示、反向工程等行为。<br><br>

五、隐私政策<br><br>

1. 信息收集：小程序运营方可能会收集您在使用小程序过程中提供的个人信息，具体收集的信息类型、目的、方式等将在隐私政策中详细说明 。<br><br>

2. 信息使用与保护：小程序运营方将按照隐私政策的规定使用和保护您的个人信息，不会向第三方泄露您的个人信息，除非获得您的明确同意或法律法规另有要求。<br><br>

六、责任限制与免责声明<br><br>

1. 责任限制：在法律允许的最大范围内，小程序运营方对因使用本小程序而产生的任何直接、间接、偶然、特殊、惩罚性或其他损害（包括但不限于数据丢失、业务中断、利润损失等）不承担责任，即使小程序运营方已被告知可能发生此类损害。<br><br>

2. 免责情形：对于因不可抗力（如自然灾害、战争、政府行为、网络攻击等）、第三方行为（如电信运营商网络故障、第三方软件或服务问题等）导致的小程序服务中断、数据丢失、错误等问题，小程序运营方不承担责任 。<br><br>

七、其他条款<br><br>

1. 协议的完整性：本协议构成您与小程序运营方之间关于使用本小程序的完整协议，取代之前所有关于本小程序的口头或书面协议。<br><br>

2. 条款的可分割性：如果本协议的任何条款被认定为无效或不可执行，不影响其他条款的效力和可执行性，其他条款应继续有效并执行。<br><br>

3. 争议解决：若您与小程序运营方之间因本协议引起争议，双方应首先通过友好协商解决；协商不成的，任何一方均有权将争议提交至有管辖权的人民法院诉讼解决。<br><br>

4. 协议生效：本协议自您首次使用本小程序时生效，除非小程序运营方另行通知，否则本协议将持续有效，直至您停止使用小程序或协议被依法终止。<br><br>
</div>

<div class="bottom-wrap flex-rowc">
      <div class="bottom-wrap-return flex-rowc" @click="handleReturn">
        <span class="icon"></span> 返回
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "UserAgreement",
  data() {
    return {
    };
  },
  methods: {
    handleReturn() {
      this.$router.back();
    },
  }
};
</script>
<style lang="less" scoped>
.page-detail {
  box-sizing: border-box;
  font-size: 36px;
  background: #fafafa;
  padding: 120px 50px 320px;
  .txt {
    line-height: 46px;
  }

  .bottom-wrap {
    padding: 25px 0 90px;
    box-sizing: border-box;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    .bottom-wrap-return {
      flex-shrink: 0;
      font-size: 30px;
      color: #747474;
      .icon {
        display: inline-block;
        width: 42px;
        height: 42px;
        background: url("../../assets/images/return-icon2.png") no-repeat
          center;
        background-size: cover;
        margin-right: 10px;
      }
    }
    .bottom-wrap-btn {
      width: 280px;
      height: 69px;
      border-radius: 44px;
      border: 2px solid #0041c8;
      box-sizing: border-box;
      margin-left: 50px;
      color: #0041c8;
      font-size: 30px;
      background: #fff;
    }
  }
}
</style>